import { render, staticRenderFns } from "./changeBindAccount.vue?vue&type=template&id=05fc19d8&scoped=true"
import script from "./changeBindAccount.vue?vue&type=script&lang=js"
export * from "./changeBindAccount.vue?vue&type=script&lang=js"
import style0 from "./changeBindAccount.vue?vue&type=style&index=0&id=05fc19d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fc19d8",
  null
  
)

export default component.exports